import { render, staticRenderFns } from "./preview-uploadimg.vue?vue&type=template&id=ee562d8c&scoped=true"
import script from "./preview-uploadimg.vue?vue&type=script&lang=js"
export * from "./preview-uploadimg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee562d8c",
  null
  
)

export default component.exports